import { render, staticRenderFns } from "./FeatureDHZB.vue?vue&type=template&id=5efdfcd0&scoped=true"
import script from "./FeatureDHZB.vue?vue&type=script&lang=js"
export * from "./FeatureDHZB.vue?vue&type=script&lang=js"
import style0 from "./FeatureDHZB.vue?vue&type=style&index=0&id=5efdfcd0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5efdfcd0",
  null
  
)

export default component.exports